import { STATUS_CADRE } from "@/tools/enum";

export const ALL_EVENTS = "ALL_EVENTS";
export const AVAILABLE_DEPARTMENT = "AVAILABLE_DEPARTMENT";
export const AVAILABLE_STORE = "AVAILABLE_STORE";
export const AVAILABLE_SUBTYPE = "AVAILABLE_SUBTYPE";
export const CALENDAR_TIME_SLOTS = "CALENDAR_TIME_SLOTS";
export const CALENDAR_EVENTS = "CALENDAR_EVENTS";
export const CUSTOMER_ID = "CUSTOMER_ID";
export const CUSTOMER_TYPE = "CUSTOMER_TYPE";
export const CUSTOMER_STATUS = "CUSTOMER_STATUS";
export const EVENT = "EVENT";
export const EVENT_DATE = "EVENT_DATE";
export const EVENT_DURATION = "EVENT_DURATION";
export const EVENT_ORDER_NOTE = "EVENT_ORDER_NOTE";
export const EVENT_QUANTITY = "EVENT_QUANTITY";
export const EVENT_SUBTYPE = "EVENT_SUBTYPE";
export const EVENT_TIME = "EVENT_TIME";
export const EVENT_TIME_SLOT = "EVENT_TIME_SLOT";
export const EVENT_CATEGORY = "EVENT_CATEGORY";
export const FIRST_TIME_SLOT = "FIRST_TIME_SLOT";
export const EVENT_TYPES = "EVENT_TYPES";
export const EVENT_TYPE = "EVENT_TYPE";
export const EVENT_TYPE_LABEL = "EVENT_TYPE_LABEL";
export const EVENT_TYPE_FIELD_APP = "EVENT_TYPE_FIELD_APP";
export const EVENT_TYPE_FIELD_APPLICATION = "EVENT_TYPE_FIELD_APPLICATION";
export const EVENT_TYPE_PICKING = "EVENT_TYPE_PICKING";
export const EVENT_TYPE_FOLDER = "EVENT_TYPE_FOLDER";
export const TO_BE_PLANNED_EVENT = "TO_BE_PLANNED_EVENT";
export const SELECTED_TIME_SLOT = "SELECTED_TIME_SLOT";
export const EXPIRE_AT = "EXPIRE_AT";
export const IS_AUTHENTICATED = "IS_AUTHENTICATED";
export const HAS_DOMICILE = "HAS_DOMICILE";
export const DOMICILE = "DOMICILE";
export const CALENDAR_OWNER_DOMICILE = "CALENDAR_OWNER_DOMICILE";
export const GET_IMPERSONATE = "GET_IMPERSONATE";
export const NOTIFICATION = "NOTIFICATION";
export const NUMBER_NOTIFICATION = "NUMBER_NOTIFICATION";
export const GET_GESTION_LEVEL = "GET_GESTION_LEVEL";
export const IS_HOLIDAY_YEAR_LOADED = "IS_HOLIDAY_YEAR_LOADED";
export const IS_HOLIDAY = "IS_HOLIDAY";
export const IS_MANAGER = "IS_MANAGER";
export const IS_ONLY_AUDITOR = "IS_ONLY_AUDITOR";
export const IS_ONLY_AUDITOR_CADRE = "IS_ONLY_AUDITOR_CADRE";
export const IS_RH = "IS_RH";
export const IS_MANAGER_OF_EVENT_PARTICIPANT =
  "IS_MANAGER_OF_EVENT_PARTICIPANT";
export const IS_SKILLED_FOR_EVENT_TYPE = "IS_SKILLED_FOR_EVENT_TYPE";
export const HAS_REFRESH_TOKEN = "HAS_REFRESH_TOKEN";
export const USERNAME_BY_ID = "USERNAME_BY_ID";
export const EVENT_TYPE_LOCAL_WORKFLOW = "EVENT_TYPE_LOCAL_WORKFLOW";
export const EVENT_CREDIT_ID = "EVENT_CREDIT_ID";
export const EVENT_CREDIT_REMAIN = "EVENT_CREDIT_REMAIN";
export const EVENT_CREDIT_REMAIN_BY_YEAR = "EVENT_CREDIT_REMAIN_BY_YEAR";
export const EVENT_LINKED_CREDIT = "EVENT_LINKED_CREDIT";
export const REST_WORK_TIME = "REST_WORK_TIME";
export const EVENT_PARTICIPANT_STATUS = "EVENT_PARTICIPANT_STATUS";
export const EVENT_PARTICIPANT = "EVENT_PARTICIPANT";
export const SUPERVISION_FILTERS_ENABLED = "SUPERVISION_FILTERS_ENABLED";
export const CALENDAR_OWNERS = "CALENDAR_OWNERS";
export const CALENDAR_OWNERS_NOT_FICTIF = "CALENDAR_OWNERS_NOT_FICTIF";
export const CALENDAR_OWNERS_EXCEPT = "CALENDAR_OWNERS_EXCEPT";
export const IS_DESCRIPTION_REQUIRED = "IS_DESCRIPTION_REQUIRED";
export const DEPARTMENTS = "DEPARTMENTS";
export const BUSINESS_GROUPS = "BUSINESS_GROUPS";
export const BUSINESS_GROUP = "BUSINESS_GROUP";
export const HAS_EVENT_RULE = "HAS_EVENT_RULE";
export const EVENT_CREDIT_CAN_BE_NEGATIVE = "EVENT_CREDIT_CAN_BE_NEGATIVE";
export const IS_IMPERSONATE_ADMIN = "IS_IMPERSONATE_ADMIN";
export const GET_CALENDAR_DATE = "GET_CALENDAR_DATE";
export const GET_CALENDAR_DATE_START_OF_WEEK =
  "GET_CALENDAR_DATE_START_OF_WEEK";
export const GET_CALENDAR_YEAR = "GET_CALENDAR_YEAR";
export const GET_CALENDAR_ISO_WEEK = "GET_CALENDAR_ISO_WEEK";
export const SELECTED_CALENDAR_EVENT = "SELECTED_CALENDAR_EVENT";
export const MAIN_FOLDER = "MAIN_FOLDER";
export const IS_ADMIN = "IS_ADMIN";
export const IS_FICTIF = "IS_FICTIF";
export const GET_IMPERSONATION_REDIRECT_PATH =
  "GET_IMPERSONATION_REDIRECT_PATH";

const nestObjectRegex = /^([A-Za-z]+)_([A-Za-z]+)$/;

import dayjs from "dayjs";
import { isArray, isNullish, isString } from "remeda";
import { isNonNullish } from "remeda";

export default {
  [ALL_EVENTS]: (state) => {
    let items = [];
    Object.keys(state.items).forEach((eventId) => {
      let event = { ...state.items[eventId] };
      let tSlotDate = [];
      let tSlotRemasterised = [];
      let tSlotBreakDuration = [];
      event.date = tSlotDate;
      event.timeSlots = tSlotRemasterised;
      event.break_duration = tSlotBreakDuration;

      let timeSlot = state.timeSlots.filter(
        (timeSlot) => timeSlot.eventId === parseInt(eventId)
      );
      timeSlot.forEach((ts) => {
        event.date.push(ts.date);
        event.timeSlots.push(
          "de " +
            ts.time.replace(":", "h") +
            " à " +
            dayjs(ts.date + "T" + ts.time)
              .add(ts.duration, "m")
              .format("H[h]mm")
        );
        event.break_duration.push(
          ts.break_duration !== undefined ? ts.break_duration : 0
        );
      });
      items.push(event);
    });

    return items;
  },
  [AVAILABLE_DEPARTMENT]: (state) => {
    const departments = [];

    state.toBePlannedEvents.forEach((eventId) => {
      const event = state.items[eventId];

      if (!departments.includes(event.department)) {
        const department = state.departments.find(
          (department) => department.name === event.department
        );

        if (department) {
          departments.push(department);
        }
      }
    });

    return departments;
  },
  [AVAILABLE_STORE]: (state) => {
    let stores = [];

    state.toBePlannedEvents.forEach((eventId) => {
      let event = state.items[eventId];
      if (
        "store" in event &&
        event.store !== undefined &&
        !stores.includes(event.store)
      ) {
        stores.push(event.store);
      }
    });

    return stores;
  },
  [AVAILABLE_SUBTYPE]: (state) => {
    let subtypes = [];

    state.toBePlannedEvents.forEach((eventId) => {
      let name = state.items[eventId].subtype;
      if (!subtypes.includes(name)) {
        subtypes.push({
          name: name,
          label: state.eventTypes[name].label,
        });
      }
    });

    return subtypes;
  },
  [CALENDAR_TIME_SLOTS]: (state) => {
    const map = {};
    state.timeSlots.forEach((timeSlot) => {
      (map[timeSlot.date] = map[timeSlot.date] || []).push(timeSlot);
    });

    return map;
  },
  [CALENDAR_EVENTS]: (state) => {
    return state.timeSlots.map((timeSlot) => {
      const event = state.items[timeSlot.eventId];

      if (timeSlot.date && timeSlot.time) {
        const date = dayjs(`${timeSlot.date} ${timeSlot.time}`);

        return {
          start: date.toDate().getTime(),
          end: date.add(timeSlot.duration, "minute").toDate().getTime(),
          dynamic: false,
          timed: true,
          timeSlot,
          event,
        };
      }

      return {
        start: 0,
        end: timeSlot.duration * 1000 * 60,
        dynamic: false,
        timed: true,
        timeSlot,
        event,
      };
    });
  },
  [EVENT]: (state) => (eventId) => {
    return state.items[eventId];
  },
  [EVENT_DATE]: (state) => (eventId) => {
    return state.items[eventId].date;
  },
  [EVENT_DURATION]: (state) => (eventId) => {
    const event = state.items[eventId];
    return event ? event.duration : null;
  },
  [EVENT_ORDER_NOTE]: (state) => (eventId) => {
    const event = state.items[eventId];
    return event ? event.description : null;
  },
  [EVENT_QUANTITY]: (state) => (eventId) => {
    if (eventId in state.items) {
      return state.items[eventId].quantity;
    }
    return null;
  },
  [EVENT_SUBTYPE]: (state) => (eventId) => {
    return state.eventTypes[state.items[eventId].subtype].label;
  },
  [EVENT_TIME]: (state) => (eventId) => {
    return state.timeSlots.filter((timeSlot) => timeSlot.eventId === eventId)[0]
      .time;
  },
  [EVENT_TIME_SLOT]: (state) => (eventId) => {
    return state.timeSlots.filter((timeSlot) => timeSlot.eventId === eventId);
  },
  [EVENT_CATEGORY]: (state) => (eventId) => {
    return state.items[eventId].category;
  },
  [FIRST_TIME_SLOT]: (state) => (Id) =>
    state.timeSlots.filter(
      (IdtimeSlot) => IdtimeSlot.eventId === parseInt(Id)
    )[0],
  [EVENT_TYPES]: (state) => (category) => {
    let eventTypes = [];
    Object.keys(state.eventTypes).forEach(function (name) {
      if (
        !state.eventTypes[name].disabled &&
        (category === undefined || state.eventTypes[name].category === category)
      ) {
        eventTypes.push({
          name: name,
          label: state.eventTypes[name].label,
          isLvl1: state.eventTypes[name].require_level1,
        });
      }
    });

    return eventTypes;
  },
  [EVENT_TYPE]: (state) => (eventTypeName) => {
    return state.eventTypes[eventTypeName];
  },
  [EVENT_TYPE_LABEL]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      return state.eventTypes[eventTypeName].label;
    }

    return eventTypeName;
  },
  [EVENT_TYPE_FIELD_APP]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      return state.eventTypes[eventTypeName].is_fieldapp;
    }

    return false;
  },
  /**
   * @returns {(function(string): ({id: number, name: string}|null))}
   */
  [EVENT_TYPE_FIELD_APPLICATION]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      return state.eventTypes[eventTypeName]?.field_application ?? null;
    }

    return null;
  },
  [EVENT_TYPE_PICKING]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      return state.eventTypes[eventTypeName].pickable;
    }

    return false;
  },
  [EVENT_TYPE_FOLDER]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      return state.eventTypes[eventTypeName].foldersFirstCode;
    }

    return false;
  },
  [SELECTED_TIME_SLOT]: (state) => state.selectedTimeSlot,
  [TO_BE_PLANNED_EVENT]: (state) => {
    let events = state.toBePlannedEvents.map((eventId) => state.items[eventId]);

    if (state.eventSearch) {
      const search = state.eventSearch.toLocaleLowerCase();

      events = events.filter((event) => {
        return (
          state.eventTypes[event.subtype].label
            .toLocaleLowerCase()
            .indexOf(search) > -1 ||
          event.referenceBusiness.toLocaleLowerCase().indexOf(search) > -1 ||
          event.referenceBusinessDivalto.toLocaleLowerCase().indexOf(search) >
            -1 ||
          (event.city && event.city.toLocaleLowerCase().indexOf(search) > -1)
        );
      });
    }

    return events.filter((event) => {
      let valid = true;

      Object.keys(state.eventFilters).forEach((key) => {
        const filter = state.eventFilters[key];

        if (nestObjectRegex.test(filter.name)) {
          let matches = filter.name.match(nestObjectRegex);
          valid &&=
            event[matches[1]] && event[matches[1]][matches[2]] === filter.value;
        } else if (filter.name === "datesDeadline") {
          if (isNullish(filter.value?.end)) {
            valid &&= dayjs(event.deadline).isSameOrAfter(
              filter.value.start,
              "day"
            );
          } else {
            valid &&= dayjs(event.deadline).isBetween(
              filter.value.start,
              filter.value.end,
              "day",
              "[]"
            );
          }
        } else if (
          filter.name === "datesReport" &&
          isNonNullish(event.report)
        ) {
          if (isNullish(filter.value?.end)) {
            valid &&= dayjs(event.report).isSameOrAfter(
              filter.value.start,
              "day"
            );
          } else {
            valid &&= dayjs(event.report).isBetween(
              filter.value.start,
              filter.value.end,
              "day",
              "[]"
            );
          }
        } else if (filter.name === "report") {
          valid &&= filter.value
            ? isNonNullish(event.report)
            : isNullish(event.report);
        } else {
          valid &&= event[filter.name] === filter.value;
        }
      });

      return valid;
    });
  },
  [EXPIRE_AT]: (state) => state.security.expireAt,
  [IS_AUTHENTICATED]: (state) => {
    return !!state.security.token;
  },
  [DOMICILE]: (state) => state.customer.domicile,
  [CALENDAR_OWNER_DOMICILE]: (state) => (id) => {
    const owner = state.calendarOwners.find((owner) => owner.id === id);

    if (!owner) {
      return undefined;
    }

    return owner?.domicile ?? undefined;
  },
  [HAS_DOMICILE]: (state) => state.customer.domicile !== undefined,
  [GET_IMPERSONATE]: (state) => state.impersonate !== undefined,
  [NOTIFICATION]: (state) => state.notifications,
  [NUMBER_NOTIFICATION]: (state) => state.notificationCount,
  [IS_HOLIDAY_YEAR_LOADED]: (state) => (year) =>
    state.loadedHolidayYears.includes(year),
  [IS_HOLIDAY]: (state) => (date) => state.holidays.includes(date),
  [IS_ONLY_AUDITOR]: (state) =>
    state.customer.roles.length === 1 &&
    state.customer.roles.includes("ROLE_PLANIFICATION"),
  [GET_GESTION_LEVEL]: (state) => {
    let level = 0;

    for (const role of state.customer.roles) {
      const match = role.match(/^ROLE_GESTION_(\d+)$/);

      if (match !== null) {
        level = Math.max(level, +match[1]);
      }
    }

    return level;
  },
  [IS_MANAGER]: (state) => state.customer.roles.includes("ROLE_GESTION_1"),
  [IS_ONLY_AUDITOR_CADRE]: (state, getters) => {
    const status = getters[CUSTOMER_STATUS](state.calendarDate);

    return (
      state.customer.roles.includes("ROLE_PLANIFICATION") &&
      status === STATUS_CADRE
    );
  },
  [IS_RH]: (state) => state.customer.roles.includes("RH"),
  [EVENT_PARTICIPANT_STATUS]: (state) => (id) => {
    const owner = state.calendarOwners.find((owner) => owner.id === id);

    if (owner) {
      return findStatus(owner.status_history);
    }

    return null;
  },
  [EVENT_PARTICIPANT]: (state) => (id) => {
    return state.calendarOwners.find(
      (calendarOwner) => calendarOwner.id === id
    );
  },
  [IS_MANAGER_OF_EVENT_PARTICIPANT]: (state) => (eventId) => {
    const participant = state.items[eventId].participant;
    const owner = state.calendarOwners.find((owner) => {
      return owner.fullName === participant;
    });

    if (!owner || !owner.manager) {
      return false;
    }

    return owner.manager === state.customer.id;
  },
  [IS_SKILLED_FOR_EVENT_TYPE]: (state) => (eventType) => {
    return state.customer.skills && state.customer.skills.includes(eventType);
  },
  [HAS_REFRESH_TOKEN]: (state) => {
    return !!state.security.refreshToken;
  },
  [USERNAME_BY_ID]: (state) => (id) => {
    let owner = state.calendarOwners.find((owner) => owner.id === id);

    if (owner) {
      return owner.username;
    }

    return null;
  },
  [CUSTOMER_ID]: (state) => {
    return state.customer.id;
  },
  [CUSTOMER_TYPE]: (state) => {
    return state.customer.type;
  },
  [CUSTOMER_STATUS]: (state) => {
    /**
     * @param {string} date
     */
    return (date) => {
      return findStatus(state.customer.status_history, date);
    };
  },
  [EVENT_TYPE_LOCAL_WORKFLOW]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      return state.eventTypes[eventTypeName].localWorkflow;
    }

    return false;
  },

  [EVENT_CREDIT_REMAIN]: (state) => (eventTypeName) => {
    const creditValues = getLinkedCreditValues(state, eventTypeName);

    if (creditValues.length === 0) {
      return false;
    }

    return creditValues.reduce((acc, currentCreditValue) => {
      if (currentCreditValue.value) {
        acc += currentCreditValue.value;
      }

      return acc;
    }, 0);
  },

  [EVENT_CREDIT_REMAIN_BY_YEAR]: (state) => (eventTypeName) => {
    const creditValues = getLinkedCreditValues(state, eventTypeName);

    if (creditValues.length === 0) {
      return false;
    }

    return creditValues.reduce((acc, currentCreditValue) => {
      const keyValue = currentCreditValue.year;

      if (currentCreditValue.value) {
        acc[keyValue] = acc?.[keyValue]
          ? acc[keyValue] + currentCreditValue.value
          : currentCreditValue.value;
      }

      return acc;
    }, {});
  },

  [EVENT_CREDIT_ID]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      if (state.eventTypes[eventTypeName].linked_credit) {
        const labelCredit = state.eventTypes[eventTypeName].linked_credit.label;
        const credit = state.credits.find(
          (credit) => credit.label === labelCredit
        );

        if (credit) {
          return credit.id;
        }
        return false;
      }
      return false;
    }
    return false;
  },

  [EVENT_CREDIT_CAN_BE_NEGATIVE]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      if (state.eventTypes[eventTypeName].linked_credit) {
        const labelCredit = state.eventTypes[eventTypeName].linked_credit.label;
        const credit = state.credits.find(
          (credit) => credit.label === labelCredit
        );

        if (credit) {
          return credit.canBeNegative;
        }

        return false;
      }
      return false;
    }
    return false;
  },

  [EVENT_LINKED_CREDIT]: (state) => (eventTypeName) => {
    if (eventTypeName in state.eventTypes) {
      return !!state.eventTypes[eventTypeName].linked_credit;
    }
    return false;
  },

  [REST_WORK_TIME]: (state) => {
    return state.restWorkTime;
  },

  [SUPERVISION_FILTERS_ENABLED]: (state) => {
    if (!state.supervisionFiltersEnabled) {
      const storageFiltersEnabled = localStorage.getItem(
        "supervision-filters-enabled"
      );

      if (storageFiltersEnabled) {
        return JSON.parse(storageFiltersEnabled);
      }
    }

    return state.supervisionFiltersEnabled;
  },

  [CALENDAR_OWNERS]: (state) => (types) => {
    if (types.length) {
      return state.calendarOwners.filter((calendarOwner) =>
        types.includes(calendarOwner.type)
      );
    }

    return state.calendarOwners;
  },

  [CALENDAR_OWNERS_NOT_FICTIF]: (state) => (types) => {
    const userNamed = state.calendarOwners.filter(
      (calendarOwner) => calendarOwner.fictif !== true
    );

    if (types.length) {
      return userNamed.filter((calendarOwner) =>
        types.includes(calendarOwner.type)
      );
    }

    return userNamed;
  },

  [CALENDAR_OWNERS_EXCEPT]: (state) => (types) => {
    if (types.length) {
      return state.calendarOwners.filter(
        (calendarOwner) => !types.includes(calendarOwner.type)
      );
    }

    return state.calendarOwners;
  },
  [IS_DESCRIPTION_REQUIRED]: (state) => (subtype_name) => {
    const exceptions = ["delegation", "road", "night_outside_home"];

    return (
      !exceptions.includes(subtype_name) &&
      subtype_name in state.eventTypes &&
      "category" in state.eventTypes[subtype_name] &&
      state.eventTypes[subtype_name].category === "other"
    );
  },

  [DEPARTMENTS]: (state) => state.departments,

  [BUSINESS_GROUPS]: (state) => state.businessGroups,

  [BUSINESS_GROUP]: (state) => (id) => {
    return state.businessGroups.find(
      (businessGroup) => businessGroup.id === id
    );
  },

  [HAS_EVENT_RULE]: (state) => (eventId) => {
    return state.eventRules.includes(eventId);
  },

  [IS_IMPERSONATE_ADMIN]: (state) => {
    return !!(state.impersonate && state.impersonate.admin);
  },

  [GET_CALENDAR_DATE]: (state) => {
    return state.calendarDate;
  },

  [GET_CALENDAR_DATE_START_OF_WEEK]: (state) => {
    const calendarDate = dayjs(state.calendarDate);

    if (calendarDate && calendarDate.isValid()) {
      return calendarDate.startOf("week").format("YYYY-MM-DD");
    }

    return dayjs().startOf("week").format("YYYY-MM-DD");
  },

  [GET_CALENDAR_YEAR]: (state) => {
    const calendarDate = dayjs(state.calendarDate);

    if (calendarDate && calendarDate.isValid()) {
      return calendarDate.year();
    }

    return new Date().getFullYear();
  },

  [GET_CALENDAR_ISO_WEEK]: (state) => {
    const calendarDate = dayjs(state.calendarDate);

    if (!calendarDate.isValid()) {
      return null;
    }

    return {
      year: calendarDate.isoWeekYear(),
      weekNumber: calendarDate.isoWeek(),
    };
  },

  [SELECTED_CALENDAR_EVENT]: (state) => state.selectedCalendarEvent,

  [MAIN_FOLDER]: (state) => state.customer?.main_folder,

  [IS_ADMIN]: (state) => {
    return !!state.customer?.roles?.includes("ROLE_ADMIN");
  },

  [IS_FICTIF]: (state) => {
    return !!state.customer?.fictif;
  },

  [GET_IMPERSONATION_REDIRECT_PATH]: (state) => {
    return state.impersonationRedirectPath;
  },
};

/**
 * @param {any} state
 * @param {string} eventTypeName
 * @return {Array}
 */
function getLinkedCreditValues(state, eventTypeName) {
  if (!Object.prototype.hasOwnProperty.call(state.eventTypes, eventTypeName)) {
    return [];
  }

  const linkedCredit = state.eventTypes[eventTypeName].linked_credit;

  if (!linkedCredit) {
    return [];
  }

  return state.credits.filter((credit) => {
    return credit.label === linkedCredit.label;
  });
}

/**
 * @param {array} statusHistory
 * @param {string} date
 */
function findStatus(statusHistory, date = null) {
  if (!isArray(statusHistory)) {
    return null;
  }

  let dayjsDate = null;

  if (isString(date)) {
    dayjsDate = dayjs(date);
  } else {
    dayjsDate = dayjs();
  }

  const found = statusHistory.find((item) => {
    if (isNonNullish(item.start) && isNonNullish(item.end)) {
      return dayjsDate.isBetween(item.start, item.end, "day", "[]");
    }

    if (isNonNullish(item.start) && isNullish(item.end)) {
      return dayjsDate.isSameOrAfter(item.start, "day");
    }

    if (isNullish(item.start) && isNonNullish(item.end)) {
      return dayjsDate.isSameOrBefore(item.end, "day");
    }

    return false;
  });

  if (isNonNullish(found)) {
    return found.status;
  }

  return null;
}
